const minLenght = (value: number) => ({
  minLength: {
    value,
    message: 'minLength',
  },
});
const maxLenght = (value: number) => ({
  maxLength: {
    value,
    message: 'maxLength',
  },
});

const min = (value: number) => ({
  min: {
    value,
    message: 'min',
  },
});
const max = (value: number) => ({
  max: {
    value,
    message: 'max',
  },
});

const required = { required: 'Obbligatorio' };

const pattern = {
  nAn: {
    pattern: {
      value: /^\d+$/,
      message: 'Solo caratteri numerici consentiti.',
    },
  },
  taxCode: {
    pattern: {
      value: /^[A-Za-z]{6}[0-9]{2}[A-Za-z]{1}[0-9]{2}[A-Za-z]{1}[0-9]{3}[A-Za-z]{1}$/i,
      message: 'Codice fiscale non valido.',
    },
  },
  email: {
    pattern: {
      value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
      message: 'Email non valida.',
    },
  },
  password: {
    pattern: {
      value: /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])[\w~!-@#$&*]{6,20}$/,
      message:
        'La password deve essere compresa tra 6 e 20 caratteri, avere una lettera maiuscola, una minuscola, un carattere numerico e opzionalmente un carattere speciale (!-@#$&*).',
    },
  },
  blank: {
    pattern: {
      value: /^\S+$/i,
      message: 'Spazi bianchi non consentiti.',
    },
  },
  letters: {
    pattern: {
      value: /^[a-zA-Z]+$/i,
      message: 'Solo lettere consentite.',
    },
  },
  username: {
    pattern: {
      value: /^[a-zA-Z0-9-_.]+$/,
      message: 'Spazi bianchi o caratteri non consentiti.',
    },
  },
  website: {
    pattern: {
      value:
        /^https?:\/\/(?:www\.|(?!www)[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|www\.[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9]+\.[^\s]{2,}|www\.[a-zA-Z0-9]+\.[^\s]{2,})+$/,
      message: 'Sito web non valido',
    },
  },
  name: {
    pattern: {
      value: /^[^!@#$%^&*()_+\-=\\[\]{};':"\\|,.<>\\/?]+$/,
      message: 'Caratteri non consentiti.',
    },
  },
  fiscalCode: {
    pattern: {
      value: /^[A-Z]{6}[0-9]{2}[A-Z][0-9]{2}[A-Z][0-9]{3}[A-Z]$/,
      message: 'Codice fiscale non valido.',
    },
  },
};

export const validationSchema = {
  required,
  userName: {
    ...required,
    ...minLenght(3),
    ...maxLenght(50),
    ...pattern.username,
  },
  social: {
    ...minLenght(3),
    ...maxLenght(50),
    ...pattern.username,
  },
  website: {
    ...pattern.website,
  },
  password: {
    ...required,
    ...pattern.password,
  },
  confirmPassword: {
    ...required,
    match: {
      message: 'Le password non corrispondono',
    },
  },
  firstName: {
    ...required,
    ...maxLenght(50),
    ...pattern.name,
  },
  lastName: {
    ...required,
    ...maxLenght(50),
    ...pattern.name,
  },
  companyName: {
    ...required,
    ...minLenght(3),
    ...maxLenght(50),
  },
  taxCode: {
    ...required,
    ...pattern.taxCode,
  },
  mobileLine: {
    ...required,
    ...minLenght(8),
    ...maxLenght(20),
    ...pattern.nAn,
  },
  landLine: {
    ...minLenght(8),
    ...maxLenght(20),
    ...pattern.nAn,
  },
  rui: {
    ...required,
    ...minLenght(9),
    ...maxLenght(9),
  },
  vat: {
    ...required,
    ...minLenght(11),
    ...maxLenght(13),
  },
  email: {
    ...required,
    ...pattern.email,
  },
  emailNotRequired: {
    ...pattern.email,
  },
  street: {
    ...required,
    ...minLenght(3),
    ...maxLenght(50),
  },
  streetNumber: {
    ...required,
    ...maxLenght(5),
    ...pattern.nAn,
  },
  zipCode: {
    ...required,
    ...maxLenght(5),
    ...pattern.nAn,
  },
  town: {
    ...required,
    ...minLenght(3),
    ...maxLenght(50),
  },
  province: {
    ...required,
    ...maxLenght(2),
    ...pattern.letters,
  },
  locationName: {
    ...required,
    ...minLenght(2),
  },
  // TODO define fiscal code validation
  fiscalCode: {
    ...pattern.fiscalCode,
  },
  productName: {
    ...required,
    ...minLenght(3),
    ...maxLenght(50),
  },
  productCode: {
    ...required,
  },
  lotCode: {
    ...required,
  },
  lotQuantity: {
    ...required,
    ...pattern.nAn,
    ...min(1),
    ...max(2147483647),
  },
  certificateName: {
    ...required,
    ...minLenght(3),
    ...maxLenght(50),
  },
  certificateDescription: {
    ...minLenght(3),
    ...maxLenght(250),
  },
};
